import React, { useState } from "react";
import { toast } from "sonner";
import { Button } from "../ui/button";
import { Card, CardContent } from "../ui/card";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Textarea } from "../ui/textarea";

export const Bim3DContactSection = () => {
  const [form, setForm] = useState({ name: "", company: "", email: "", phone: "", message: "" });

  const handleSubmit = (event) => {
    event.preventDefault();
    localStorage.setItem("bimcubes_bim3d_contact", JSON.stringify(form));
    toast.success("Votre demande a bien été enregistrée.");
    setForm({ name: "", company: "", email: "", phone: "", message: "" });
  };

  return (
    <section className="px-4 pb-16 pt-8 sm:px-6 lg:px-8 lg:pb-24" data-testid="bim3d-contact-section">
      <div className="mx-auto max-w-[1520px] rounded-[2.8rem] border border-[#d9e7d5]/85 bg-[linear-gradient(140deg,_rgba(255,255,255,0.95)_0%,_rgba(240,253,244,0.95)_38%,_rgba(254,252,232,0.92)_100%)] p-10 shadow-[0_36px_96px_-58px_rgba(15,118,110,0.24)] sm:p-12 lg:p-16">
        <div className="max-w-4xl">
          <div className="text-sm font-semibold uppercase tracking-[0.22em] text-[#0f766e]" data-testid="bim3d-contact-eyebrow">
            Contact / demande de devis
          </div>
          <h2 className="bim-display mt-4 text-4xl font-semibold tracking-tight text-slate-950 sm:text-5xl" data-testid="bim3d-contact-title">
            Vous avez un projet BIM 3D ou une mission de synthèse ?
          </h2>
          <p className="mt-6 text-lg leading-9 text-slate-600" data-testid="bim3d-contact-description">
            Envoyez-nous les premières informations de votre projet. Bimcubes pourra vous recontacter pour préciser le périmètre, les livrables et le planning.
          </p>
        </div>

        <div className="mt-12 grid gap-8 lg:grid-cols-[1.15fr_0.85fr]">
          <Card className="rounded-[2rem] border border-[#d9e7d5]/90 bg-white/90 shadow-[0_28px_76px_-50px_rgba(15,118,110,0.2)]" data-testid="bim3d-contact-form-card">
            <CardContent className="p-8 sm:p-10">
              <form className="grid gap-5" onSubmit={handleSubmit}>
                <div className="grid gap-5 md:grid-cols-2">
                  <div>
                    <Label htmlFor="bim3d-contact-name">Nom</Label>
                    <Input data-testid="bim3d-contact-name-input" id="bim3d-contact-name" onChange={(e) => setForm({ ...form, name: e.target.value })} value={form.name} />
                  </div>
                  <div>
                    <Label htmlFor="bim3d-contact-company">Société</Label>
                    <Input data-testid="bim3d-contact-company-input" id="bim3d-contact-company" onChange={(e) => setForm({ ...form, company: e.target.value })} value={form.company} />
                  </div>
                  <div>
                    <Label htmlFor="bim3d-contact-email">Email</Label>
                    <Input data-testid="bim3d-contact-email-input" id="bim3d-contact-email" onChange={(e) => setForm({ ...form, email: e.target.value })} type="email" value={form.email} />
                  </div>
                  <div>
                    <Label htmlFor="bim3d-contact-phone">Téléphone</Label>
                    <Input data-testid="bim3d-contact-phone-input" id="bim3d-contact-phone" onChange={(e) => setForm({ ...form, phone: e.target.value })} value={form.phone} />
                  </div>
                </div>
                <div>
                  <Label htmlFor="bim3d-contact-message">Message</Label>
                  <Textarea data-testid="bim3d-contact-message-input" id="bim3d-contact-message" onChange={(e) => setForm({ ...form, message: e.target.value })} rows={6} value={form.message} />
                </div>
                <Button className="w-fit rounded-full bg-[#0f766e] px-6 text-white hover:bg-[#149289]" data-testid="bim3d-contact-submit-button" type="submit">
                  Envoyer ma demande
                </Button>
              </form>
            </CardContent>
          </Card>

          <Card className="rounded-[2rem] border border-[#d9e7d5]/90 bg-[linear-gradient(180deg,_rgba(255,255,255,0.92)_0%,_rgba(240,253,244,0.95)_100%)] shadow-[0_28px_76px_-50px_rgba(15,118,110,0.2)]" data-testid="bim3d-contact-side-card">
            <CardContent className="p-8 sm:p-10">
              <div className="text-sm font-semibold uppercase tracking-[0.22em] text-[#0f766e]" data-testid="bim3d-contact-side-eyebrow">
                Documents à préparer
              </div>
              <p className="mt-5 text-lg leading-9 text-slate-700" data-testid="bim3d-contact-side-text">
                Vous pouvez aussi préparer vos documents : plans, maquettes existantes, CCTP, DPGF, planning ou cahier des charges BIM.
              </p>
              <div className="mt-8 grid gap-3 text-sm text-slate-600" data-testid="bim3d-contact-side-list">
                {[
                  "Plans PDF / DWG",
                  "Maquettes existantes Revit / IFC",
                  "CCTP / DPGF / quantitatifs",
                  "Planning ou jalons principaux",
                  "Cahier des charges BIM / DOE",
                ].map((item) => (
                  <div className="rounded-2xl border border-white/70 bg-white/70 px-4 py-3" key={item}>
                    {item}
                  </div>
                ))}
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};